const windowRef: Record<string, any> = window;

export class Global {
    static get<T>(name: string, factory: () => T): T {
        windowRef[name] = windowRef[name] || factory();

        return windowRef[name];
    }
}
